// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__21hJi"};